import { Brain, Code, ShoppingCart, Globe, LayoutTemplate, Cloud } from "lucide-react";
import { useTranslation } from 'react-i18next';

const Services = () => {
    const { t } = useTranslation();

    const services = [
        {
            icon: Brain,
            title: t('services.aiIntegration.title'),
            description: t('services.aiIntegration.description'),
            color: "from-purple-500 to-violet-600",
            badge: t('services.aiIntegration.badge'),
        },
        {
            icon: Code,
            title: t('services.softwareDevelopment.title'),
            description: t('services.softwareDevelopment.description'),
            color: "from-blue-500 to-cyan-500",
        },
        {
            icon: ShoppingCart,
            title: t('services.ecommerce.title'),
            description: t('services.ecommerce.description'),
            color: "from-emerald-500 to-teal-500",
        },
        {
            icon: Globe,
            title: t('services.webDevelopment.title'),
            description: t('services.webDevelopment.description'),
            color: "from-orange-500 to-amber-500",
        },
        {
            icon: LayoutTemplate,
            title: t('services.wordpressDevelopment.title'),
            description: t('services.wordpressDevelopment.description'),
            color: "from-green-500 to-emerald-500",
        },
        {
            icon: Cloud,
            title: t('services.cloudSolutions.title'),
            description: t('services.cloudSolutions.description'),
            color: "from-sky-500 to-blue-600",
        },
    ];

    return (
        <section id="services" className="py-24 bg-slate-950" aria-labelledby="services-heading">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16">
                    <span className="text-blue-400 text-sm font-semibold uppercase tracking-widest mb-3 block">
                        {t('services.eyebrow')}
                    </span>
                    <h2 id="services-heading" className="text-4xl md:text-5xl font-bold text-white mb-6">
                        {t('services.title')}
                    </h2>
                    <p className="text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed">
                        {t('services.subtitle')}
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" role="list" aria-label="Our services">
                    {services.map((service, index) => (
                        <article
                            key={service.title}
                            className="group relative bg-slate-900 border border-slate-800 hover:border-blue-500/40 p-8 rounded-2xl transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/10 hover:-translate-y-1 cursor-default"
                            style={{ animationDelay: `${index * 80}ms` }}
                            role="listitem"
                        >
                            {service.badge && (
                                <span className="absolute top-5 right-5 bg-purple-500/15 border border-purple-500/30 text-purple-300 text-xs font-semibold px-2.5 py-1 rounded-full">
                                    {service.badge}
                                </span>
                            )}

                            <div
                                className={`w-14 h-14 rounded-xl bg-gradient-to-br ${service.color} p-3.5 mb-6 group-hover:scale-110 transition-transform duration-300`}
                                aria-hidden="true"
                            >
                                <service.icon className="w-7 h-7 text-white" />
                            </div>

                            <h3 className="text-xl font-bold text-white mb-3 group-hover:text-blue-400 transition-colors duration-200">
                                {service.title}
                            </h3>

                            <p className="text-gray-400 leading-relaxed text-sm">
                                {service.description}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
